<template>
  <div class="task_content">
    <div class="content_info">
      <div class="task_sign">
        <!-- 签到 -->
        <ul class="sign_day">
          <li v-for="(item, index) in signreward" :key="index">
            <img :src="getSignAward(item.day)" alt="" class="box" />
            <img
              :src="getSignTask(item.status, item.day)"
              alt=""
              class="task_state"
            />
            <p>第{{ item.day }}天</p>
            <span v-if="item.status == 1">已领取</span>
            <span
              class="wait_get"
              @click="getSignReward(item)"
              v-else-if="item.status == 0 && props.nowDay >= item.day"
            >
              待领取</span
            >
            <span v-else>待解锁</span>
          </li>
          <p>
            <span ref="progressRef"></span>
          </p>
        </ul>
      </div>
      <!-- 重复任务 -->
      <div
        class="repeat_task"
        v-for="(item, index) in state.repeatTask"
        :key="index"
      >
        <img :src="item.image_box" alt="" />
        <p>{{ item.title }}</p>
        <button v-show="item.finished == 3" class="unfinish">未完成</button>
        <button
          @click="getTaskReward(item)"
          class="get_reward"
          v-show="item.finished == 2"
        >
          领取
        </button>
        <button v-show="item.finished == 1">已完成</button>
      </div>
      <!-- 普通任务 -->
      <ul class="normal_task">
        <li v-for="(item, index) in state.normalTask">
          <img :src="item.image_box" alt="" />
          <p>{{ item.title }}</p>
          <button v-show="item.finished == 3" class="unfinish">未完成</button>
          <button
            @click="getTaskReward(item)"
            class="get_reward"
            v-show="item.finished == 2"
          >
            领取
          </button>
          <button v-show="item.finished == 1">已完成</button>
        </li>
      </ul>
      <p class="reload_btn">
        任务已完成？点击刷新
        <img
          src="../../../../assets/svg/reload.svg"
          alt=""
          @click="reloadTask"
          ref="reFreshbtn"
          class="rotate-image"
        />
      </p>
    </div>
  </div>
</template>
<script setup>
import {
  onMounted,
  nextTick,
  computed,
  reactive,
  ref,
  watch,
  defineEmits,
} from "vue";

const state = reactive({
  uid: "",
  //重复任务
  repeatTask: [],
  //普通任务
  normalTask: [],
  //签到任务
  signreward: [],
});

const props = defineProps({
  taskList: {
    type: Array,
    default: [],
  },
  signreward: {
    type: Array,
    default: [],
  },
  nowDay: {
    type: Number,
    default: 0,
  },
});

watch(
  () => props.signreward,
  (newVal) => {
    state.signreward = newVal;
    // console.log("父组件传值---------signreward", state.signreward);
  }
);
watch(
  () => props.taskList,
  (newVal) => {
    newVal &&
      -((state.repeatTask = props.taskList.slice(3, 4)),
      (state.normalTask = [
        ...props.taskList.slice(0, 3), // 前两个任务
        ...props.taskList.slice(4), // 从第四个任务开始到最后一个任务
      ]));
    // console.log("任务列表-----taskList", state);
  }
);
watch(
  () => props.nowDay,
  () => {
    nextTick(() => {
      initProgress(Number(props.nowDay));
      scrollSign(Number(props.nowDay));
    });
  }
);

// 进度条
const progressRef = ref(null);
onMounted(() => {
  // 将第三个挑出来，剩下的就是普通任务
  state.repeatTask = props.taskList.slice(3, 4);
  state.normalTask = [
    ...props.taskList.slice(0, 3), // 前两个任务
    ...props.taskList.slice(4), // 从第四个任务开始到最后一个任务
  ];
  state.signreward = props.signreward;

  // console.log("任务列表-----taskList", props.nowDay);
  nextTick(() => {
    initProgress(Number(props.nowDay));
    scrollSign(Number(props.nowDay));
  });
});

// 初始化进度条
const initProgress = (day) => {
  console.log("进度条", day);
  if (day === 0) {
    progressRef.value.style.width = "0%";
  } else if (day === 1) {
    progressRef.value.style.width = "5%";
  } else if (day === 2) {
    progressRef.value.style.width = "20%";
  } else if (day === 3) {
    progressRef.value.style.width = "35%";
  } else if (day === 4) {
    progressRef.value.style.width = "50%";
  } else if (day === 5) {
    progressRef.value.style.width = "65%";
  } else if (day === 6) {
    progressRef.value.style.width = "80%";
  } else if (day >= 7) {
    progressRef.value.style.width = "100%";
  }
};
// 签到奖励图片
const getSignAward = computed(() => {
  return function(day) {
    if (day == 1) {
      return require("../../../../assets/webActivity/newYear/taskImg/box_1.png");
    } else if (day == 2) {
      return require("../../../../assets/webActivity/newYear/taskImg/box_3.png");
    } else if (day == 3) {
      return require("../../../../assets/webActivity/newYear/taskImg/box_3.png");
    } else if (day == 4) {
      return require("../../../../assets/webActivity/newYear/taskImg/box_6.png");
    } else if (day == 5) {
      return require("../../../../assets/webActivity/newYear/taskImg/box_8.png");
    } else if (day == 6) {
      return require("../../../../assets/webActivity/newYear/taskImg/box_10.png");
    } else if (day == 7) {
      return require("../../../../assets/webActivity/newYear/taskImg/box_10.png");
    }
  };
});

// 获取当前签到任务状态, 根据三个状态返回不同的图片
const getSignTask = computed(() => {
  return function(status, day) {
    if (status == 1) {
      return require("../../../../assets/webActivity/newYear/taskImg/state_get.png");
    } else if (status == 0 && day <= props.nowDay) {
      return require("../../../../assets/webActivity/newYear/taskImg/state_gift.png");
    } else {
      return require("../../../../assets/webActivity/newYear/taskImg/state_lock.png");
    }
  };
});
// 将当天的任务滚动至视野内
const scrollSign = (day) => {
  // console.log("day-滚动", day);
  const signDom = document.querySelector(".task_sign");
  const signScrolldom = document.querySelector(".sign_day");
  let scrollLeft = 0;
  scrollLeft = (signScrolldom.clientWidth / 7) * (day - 2);
  signDom.scrollTo({
    behavior: "smooth",
    left: scrollLeft,
  });
};

import { getNewYearDailyRewards, getNewYearTaskRewards } from "@/api/activity";
import { getQueryString } from "../../../../utils/location";
import { Toast } from "vant";

// 领取当日奖励
let signrewardFlag = false;
const getSignReward = async (data) => {
  if (signrewardFlag) return;
  signrewardFlag = true;
  try {
    let res = await getNewYearDailyRewards({
      uid: getQueryString("uid"),
      day: data.day,
    });
    signrewardFlag = false;
    console.log("领取奖励-----------", res);
    if (res.data.code == 1) {
      // 更新签到状态
      updateNum(data.reward_amount);
      updateSignStatus(data.id);
    }
    Toast(res.data.msg);
  } catch (error) {
    signrewardFlag = false;
    console.log("每日签到领取奖励-----------", error);
  }
};

// 领取任务奖励
let taskrewardFlag = false;
const getTaskReward = async (data) => {
  // console.log("每日任务领取奖励-----------", data);
  if (taskrewardFlag) return;
  taskrewardFlag = true;
  try {
    let res = await getNewYearTaskRewards({
      uid: getQueryString("uid"),
      tid: data.tid,
    });
    taskrewardFlag = false;
    console.log("领取奖励-----------", res);
    if (res.data.code == 1) {
      // 更新剩余次数，任务状态
      updateNum(res.data.data);
      updateTaskStatus(data.id);
    }
    Toast(res.data.msg);
  } catch (error) {
    taskrewardFlag = false;
    // Toast("领取失败");
    // console.log("每日签到领取奖励-----------", error);
  }
};

const emit = defineEmits([
  "reloadTask",
  "updateCjnum",
  "updateTaskStatus",
  "updateSignStatus",
]);
var currentRotation = 0;
const reFreshbtn = ref(null);
const reloadTask = () => {
  let rotateDom = reFreshbtn.value;
  currentRotation += 360;
  rotateDom.style.transform = "rotate(" + currentRotation + "deg)";
  emit("reloadTask");
};

// 更新剩余次数
const updateNum = (num) => {
  emit("updateCjnum", num);
};

// 更新任务状态
const updateTaskStatus = (data) => {
  emit("updateTaskStatus", data);
};
// 更新日常任务状态
const updateSignStatus = (data) => {
  emit("updateSignStatus", data);
};
</script>
<style scoped>
.task_content {
  width: 100%;
  min-height: 1388px;
  background: linear-gradient(180deg, #fdb260 0%, #92e2ff 100%);
  padding: 10px 32px;
}
.content_info {
  width: 686px;
  min-height: 1368px;
  background: url(../../../../assets/webActivity/newYear/taskImg/task_bg.png),
    linear-gradient(180deg, #ffe8b5 0%, #fff0af 100%);
  background-size: 100% auto;
  background-repeat: no-repeat;
  border-radius: 40px;
  border: 2px solid #ffffff;
  position: relative;
  padding: 144px 20px 32px;
}
.task_sign {
  width: 646px;
  min-height: 384px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 30px;
  padding: 38px 18px 28px;
  backdrop-filter: blur(18px);
  overflow: auto;
  display: flex;
}

/* 签到任务 */
.task_sign .sign_day {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  position: relative;
  height: 100%;
  /* width: 100%; */
  flex-shrink: 0;
}
.task_sign .sign_day li {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* flex-shrink: 0; */
}
.task_sign .sign_day li {
  margin: 0 22px;
}
.task_sign .sign_day li .box {
  width: 160px;
  height: 160px;
}
.task_sign .sign_day li .task_state {
  width: 80px;
  height: 80px;
  position: relative;
  z-index: 2;
}
.task_sign .sign_day li .btn {
  margin-top: 18px;
  width: 100px;
  height: 44px;
}
.task_sign .sign_day > p {
  width: 97%;
  height: 16px;
  background: #fff1cd;
  box-shadow: inset 0px 2px 8px 0px rgba(197, 130, 38, 0.25);
  position: absolute;
  top: 192px;
  left: 22px;
  border-radius: 32px;
  display: flex;
}
/* 第一阶段 15%  二阶段 50% 3阶段 100%*/
.task_sign .sign_day > p span {
  display: inline-block;
  width: 0px;
  height: 16px;
  background: #56ff40;
  box-shadow: inset 0px 4px 8px 0px #ffffff;
  border-radius: 32px;
  transition: all 3s ease;
}

.task_sign .sign_day li span {
  margin-top: 18px;
  width: 100px;
  height: 44px;
  background: #c4c4c4;
  box-shadow: inset 0px -2px 0px 0px rgba(118, 118, 118, 0.25),
    inset 0px 2px 2px 0px #ffffff;
  border-radius: 40px;
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
}
.task_sign .sign_day li span.wait_get {
  background: linear-gradient(180deg, #ff4957 0%, #fa4aa0 100%);
  box-shadow: inset 0px -2px 0px 0px rgba(255, 255, 255, 0.25),
    inset 0px 2px 2px 0px #ffd3dd;
}

/* 重复任务 */
.repeat_task {
  margin-top: 16px;
  width: 100%;
  height: 132px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 30px;
  padding: 38px 40px 28px;
  backdrop-filter: blur(18px);
}
.repeat_task img,
.normal_task img {
  width: 100px;
  height: 100px;
}
.repeat_task p,
.normal_task p {
  margin-left: 20px;
  flex: 1;
  color: #922e0f;
}
.repeat_task button,
.normal_task button {
  width: 112px;
  height: 52px;
  background: #c6c6c6;
  border-radius: 198px 198px 198px 198px;
  border: 2px solid #ffffff;
  color: #fff;
}
.repeat_task button.get_reward,
.normal_task button.get_reward {
  background: linear-gradient(180deg, #ff7282 0%, #ff58c2 100%);
}
.repeat_task button.unfinish,
.normal_task button.unfinish {
  background: #ffce72;
}

/* 普通任务 */
.normal_task {
  margin-top: 16px;
  width: 646px;
  min-height: 604px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 30px;
  padding: 20px 40px 0;
  backdrop-filter: blur(18px);
}
.normal_task li {
  margin-bottom: 18px;
}

.normal_task li,
.repeat_task {
  display: flex;
  position: relative;
  align-items: center;
  font-weight: 800;
  font-size: 24px;
}

.reload_btn {
  margin: 32px 0 0;
  font-size: 20px;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reload_btn img {
  margin-left: 8px;
  width: 24px;
  height: 24px;
}

.rotate-image {
  transition: transform 0.5s;
}
</style>
